import React from 'react'
import styled, { theme, prop } from '@nobia/zeus-components/lib/styled'
import settings from '@nobia/zeus-components/lib/settings'
import { useTranslation } from '../../../utils/useTranslation'

const Wrapper = styled.div`
  background-color: ${theme('colors.white')};
  color: ${theme('colors.primary')};
  padding: 40px 30px 60px;
`

const Row = styled.div`
  &:first-child {
    margin-top: 20px;
  }

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`

const LinkRow = styled(Row)`
  margin-top: 40px;
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    margin-top: 60px;
  }
`

const H2 = styled.h2`
  text-align: center;
`

const Preamble = styled.p`
  font-size: 18px;
  font-family: 'NewSpirit-Light', serif;
  max-width: 650px;
  margin: 0 auto 20px;
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    font-size: 21px;
  }
`
const UL = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: ${prop('theme.body.tabletWidth')}) {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  @media (min-width: 1200px) {
    justify-content: center;
  }
`
const LI = styled.li`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 0 10px 10px;
  max-width: 400px;
`
const H4 = styled.h4`
  margin: 10px 0;
`
const InnerList = styled.ul`
  list-style-type: disc;
  text-align: left;
  padding: 0 25px;
  font-size: 16px;
  li {
    list-style-type: disc;
  }
`
const A = styled.a`
  margin-top: 20px;
  font-size: 16px;
  color: ${theme('colors.primary')};
  transition: color 0.5s;
  &:hover {
    color: rgba(25, 34, 40, 0.5);
  }
`

const Financing = () => {
  const { t } = useTranslation()
  return (
    <Wrapper>
      <Row>
        <H2>{t('app.finance.title')}</H2>
      </Row>
      <Row>
        <Preamble>{t('app.finance.description')}</Preamble>
      </Row>
      <Row>
        <UL>
          {settings.brand === 'magnet' && (
            <LI>
              <H4>{t('app.finance.interest-free-credit.title')}</H4>
              <InnerList>
                <li>{t('app.finance.interest-free-credit.description-1')}</li>
                <li>{t('app.finance.interest-free-credit.description-2')}</li>
                <li>{t('app.finance.interest-free-credit.description-3')}</li>
                <li>{t('app.finance.interest-free-credit.description-4')}</li>
                <li>{t('app.finance.interest-free-credit.description-5')}</li>
              </InnerList>
            </LI>
          )}
          <LI>
            <H4>{t('app.finance.buy-now-pay-later.title')}</H4>
            <InnerList>
              <li>{t('app.finance.buy-now-pay-later.description-1')}</li>
              <li>{t('app.finance.buy-now-pay-later.description-2')}</li>
              <li>{t('app.finance.buy-now-pay-later.description-3')}</li>
              <li>{t('app.finance.buy-now-pay-later.description-4')}</li>
            </InnerList>
          </LI>
          <LI>
            <H4>{t('app.finance.pay-monthly.title')}</H4>
            <InnerList>
              <li>{t('app.finance.pay-monthly.description-1')}</li>
              <li>{t('app.finance.pay-monthly.description-2')}</li>
              <li>{t('app.finance.pay-monthly.description-3')}</li>
            </InnerList>
          </LI>
          <LI>
            <H4>{t('app.finance.pay-upfront.title')}</H4>
            <InnerList>
              <li>{t('app.finance.pay-upfront.description-1')}</li>
              <li>{t('app.finance.pay-upfront.description-2')}</li>
              <li>{t('app.finance.pay-upfront.description-3')}</li>
            </InnerList>
          </LI>
        </UL>
      </Row>
      <LinkRow>
        <A href={t('app.finance.representative-examples.link')} target="_blank">
          {t('app.finance.representative-examples.description')}
        </A>
      </LinkRow>
    </Wrapper>
  )
}
export default Financing
